import React, {memo, useEffect, useState} from "react";
import {LabelTextControl} from "../index";
import {Label} from "./Label";
import { Container, StyledTextArea } from './LabelTextArea.styles';

interface LabelTextProps {
    editor: any;
    value: string;
    putData: (data: string) => void;
    labelText: string;
}

const LabelTextArea = (props: LabelTextProps) => {
    const [value, setValue] = useState(LabelTextControl.DEFAULT_VALUE);
    const [hovered, setHovered] = React.useState(false);
    const [focused, setFocused] = React.useState(false);

    const handleMouseOver = () => { setHovered(true); }
    const handleMouseOut = () => { setHovered(false); }
    const handleFocus = () => { setFocused(true); }
    const handleBlur = () => { props.editor.trigger("process"); setFocused(false); }

    const handleOnChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setValue(event.target.value);
        props.putData(event.target.value);
    };

    useEffect(() => {
        setValue(props.value);
    }, [props.value]);

    return (
        <Container>
            <Label text={props.labelText} />
            <StyledTextArea
                value={value}
                onPointerDown={e => e.stopPropagation()}
                onChange={handleOnChange}
                onMouseOver={handleMouseOver}
                onMouseOut={handleMouseOut}
                onFocus={handleFocus}
                onBlur={handleBlur}
                focused={focused}
                hovered={hovered}
            />
        </Container>
    )
};

export default memo(LabelTextArea)